import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Trophy, ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { tApi, fmtDateShort } from "@/lib/tournaments";

import { applySeo } from "@/lib/seo";
export default function AthleteProfilePage() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { tApi.get(`/rankings/athletes/${id}`).then((r) => { setA(r.data); applySeo({ title: `${r.data.name} — Athlete Profile`, description: `${r.data.name}: beach volleyball tournament results and ranking points at The Sand Lab, Chania.`, type: "profile" }); }).catch(() => setErr(true)); }, [id]);

  return (
    <div className="min-h-screen bg-[#FAF6EF]" data-testid="athlete-profile-page">
      <Navbar />
      <header className="bg-ocean text-white pt-28 pb-12 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/rankings" className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-white/70 hover:text-white mb-6" data-testid="athlete-back"><ArrowLeft className="h-3.5 w-3.5" /> Rankings</Link>
          {a && <>
            <div className="text-xs font-bold tracking-[0.3em] uppercase text-sunset mb-2">Προφίλ Αθλήτριας · ID {a.id.slice(0, 8)}</div>
            <h1 className="font-heading text-4xl sm:text-5xl font-black leading-none" data-testid="athlete-name">{a.name}</h1>
          </>}
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-8">
        {err && <div className="text-center text-slate-500 py-20">Η αθλήτρια δεν βρέθηκε.</div>}
        {!a && !err && <div className="flex justify-center py-20"><Loader2 className="h-7 w-7 animate-spin text-ocean" /></div>}
        {a && <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Stat label="Κατάταξη" value={a.ranking_position ? `#${a.ranking_position}` : "—"} testid="athlete-rank" />
            <Stat label="Πόντοι" value={a.points} testid="athlete-points" />
            <Stat label="Τουρνουά" value={a.tournaments} testid="athlete-tournaments" />
            <Stat label="Καλύτερη θέση" value={a.best?.label || "—"} testid="athlete-best" />
          </div>
          <section className="rounded-3xl bg-white border border-slate-100 shadow-soft p-6 md:p-8">
            <h2 className="font-heading text-base md:text-lg font-black text-slate-900 mb-4">Ιστορικό Τουρνουά</h2>
            {a.history.length === 0 ? <p className="text-sm text-slate-500">Δεν υπάρχουν ακόμη οριστικοποιημένα αποτελέσματα.</p> : (
              <ul className="divide-y divide-slate-100" data-testid="athlete-history">
                {a.history.map((h, i) => (
                  <li key={i} className="py-3 flex flex-wrap items-center justify-between gap-2">
                    <div>
                      <Link to={`/tournaments/${h.slug}`} className="font-bold text-ocean hover:underline">{h.title}</Link>
                      <div className="text-xs text-slate-500">{fmtDateShort(h.date)} · {h.team_name}{h.partner ? ` · συμπαίκτρια: ${h.partner}` : ""}</div>
                    </div>
                    <div className="text-right"><div className="font-heading font-black text-slate-900">{h.placement}</div><div className="text-xs text-slate-500">{h.points} πόντοι</div></div>
                  </li>
                ))}
              </ul>
            )}
          </section>
          <section className="rounded-3xl bg-white border border-slate-100 shadow-soft p-6 md:p-8">
            <h2 className="font-heading text-base md:text-lg font-black text-slate-900 mb-4">Συμπαίκτριες</h2>
            {a.partners.length === 0 ? <p className="text-sm text-slate-500">—</p> : <div className="flex flex-wrap gap-2" data-testid="athlete-partners">{a.partners.map((p) => <span key={p} className="rounded-full bg-slate-100 px-3 py-1 text-sm font-semibold text-slate-700">{p}</span>)}</div>}
          </section>
        </>}
      </main>
      <Footer />
    </div>
  );
}

const Stat = ({ label, value, testid }) => (
  <div className="rounded-3xl bg-white border border-slate-100 shadow-soft p-5 text-center" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
    <div className="font-heading font-black text-2xl text-ocean mt-1 flex items-center justify-center gap-1">{label === "Πόντοι" && <Trophy className="h-5 w-5 text-sunset" />}{value}</div>
  </div>
);
